var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarshAcceleration01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.5,235.3c-7.1,27.6-13.8,55.3-21.5,82.7c-9.5,33.8-19.8,67.3-30,100.9c-4.3,13.9-10.9,26.4-23.1,35.4 c-23.5,17.4-57,14.8-77.2-6.5c-20.7-21.7-22.7-55.6-2.6-77.4c16.9-18.3,35.3-35.4,54.1-51.8c31.8-27.8,64.5-54.6,96.8-81.8 c0.8-0.7,1.8-1.4,2.6-2C358.9,235,359.2,235.2,359.5,235.3z M280.1,406.1c0.1-16.9-13.4-30.5-30.3-30.5 c-16.8,0-30.5,13.7-30.4,30.4c0.1,16.6,13.5,30.1,30.1,30.2C266.5,436.3,280,423,280.1,406.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,164.8c-17.8,11.2-35.7,22.4-53.8,33.7c-30.4-30.1-66.1-50.8-106.9-63.8c8.1-24.9,16-49.5,24-74.1 C403.3,68.4,473.2,121.7,496,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,50.9c-2.6,8.2-5.1,15.9-7.7,23.7c-5,15.6-10.1,31.3-15.1,46.9c-0.8,2.4-1.4,4.3-4.8,3.7 c-45.8-7.1-90.6-3.3-134.6,11.3c-0.4,0.1-0.9,0.1-2.1,0.3c1.1-8,2.1-15.7,3.2-23.5c2.1-14.7,4.4-29.3,6.4-44 c0.4-2.8,1.5-4.1,4.1-5.1c36.4-13.6,74.1-19.6,112.9-17.7c11.1,0.6,22.1,2.1,33.2,3.3C317.9,50,319.3,50.5,321,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,87c-3.3,23-6.4,45-9.8,66.9c-0.3,1.7-2.5,3.5-4.2,4.5c-26.9,15.6-50.6,35.1-69.8,59.7c-8,10.3-14.6,21.6-21.7,32.5 c-0.8,1.2-1.4,2.4-2.5,3.5c2.8-34.8,14.4-66.6,33.6-95.6C68.8,129.4,93.6,106.1,124.1,87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,406.1c0-11.5,9-20.5,20.5-20.5c11.2,0.1,20.3,9.1,20.3,20.2c0.1,11.3-9.3,20.6-20.6,20.6 C238.5,426.4,229.5,417.3,229.4,406.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarshAcceleration01);
export default __webpack_public_path__ + "static/media/harshAcceleration-01.2524c8a5d7b3de6e9921b834c11d5e4e.svg";
export { ForwardRef as ReactComponent };